const localStorage = require('@/utils/localStorage')
const state = {
    params: '',
    route: '',
    domain: 'wss://cloud.stores.mankuaiaa.cn/',
    // domain: 'ws://192.168.17.47:8010/',
    heartbeat: 'websocket_heartbeat',
    webSocket: '',
    socketTask: null,
    isConn: false,
    reconnectData: null,
    lockReconnect: false,
    timeout: 5000,
    initStatus: false, //初始状态
    timeoutObj: null,
    serverTimeoutObj: null,
    callbackData: '',
}

const mutations = {
    CLEAR_CALLBACK_DATA: (state) => {
        state.callbackData = ''
    },
    SET_PARAMS: (state, params) => {
        state.params = params
    },
    SET_ROUTE: (state, route) => {
        state.route = route
    },
    INIT_WEB_SOCKET: (state) => {
        var _this = this
        console.log('启动中...');
        let url = state.domain + state.route + '/' + state.params
        if ("WebSocket" in window) {
            state.webSocket = new WebSocket(url);
            console.log('获取【 ' + url + ' 】连接通道成功')
            state.initStatus = true;
        } else {
            _this.$message.error({
                title: "提示",
                message: "当前浏览器不支持webSocket"
            });
            return;
        }

        //连接成功建立的回调方法
        state.webSocket.onopen = function () {
            console.log('连接成功')
            state.isConn = true;
            mutations.HEARTBEAT(state);//连接成功
        };

        //接收到消息的回调方法
        state.webSocket.onmessage = function (e) {
            mutations.HEARTBEAT(state); //收到消息会刷新心跳检测，如果一直收到消息，就推迟心跳发送
            console.log('收到消息', e)
            let jsonObj = JSON.parse(e.data);
            state.callbackData = jsonObj
            localStorage.cache('callbackData',jsonObj)
        };

        //连接发生错误的回调方法
        state.webSocket.onerror = function () {
            console.log('连接失败');
            state.isConn = false;
            mutations.RECONNECT(state);
        };

        //连接关闭的回调方法
        state.webSocket.onclose = function () {
            console.log('断开连接');
            state.isConn = false;
            mutations.RECONNECT(state);
        };
    },
    RECONNECT: (state) => {
        if (state.lockReconnect) {
            return;
        }
        state.lockReconnect = true;
        state.timeoutObj && clearTimeout(state.timeoutObj);
        state.reconnectData && clearTimeout(state.reconnectData);
        state.reconnectData = setTimeout(() => {
            console.log('准备重连');
            mutations.INIT_WEB_SOCKET(state)
            state.lockReconnect = false;
        }, 5000)
    },
    HEARTBEAT: (state) => {
        state.timeoutObj && clearTimeout(state.timeoutObj);
        state.serverTimeoutObj && clearTimeout(state.serverTimeoutObj);
        state.timeoutObj = setTimeout(() => {
            var message = { heartbeat: state.heartbeat };
            mutations.WEBSOCKET_SEND(state,message)
            state.serverTimeoutObj = setTimeout(() => {
                console.log('长时间未接收心跳，断开连接');
                state.webSocket.close(); //如果  5秒之后我们没有收到 后台返回的心跳检测数据 断开socket，断开后会启动重连机制
            }, 5000);
        }, state.timeout)
    },
    DELETE_DEVICE_MESSAGE_NOTICE: (state, deviceId) => {
        let message = {
            type: 'DELETE_DEVICE_MESSAGE_NOTICE',
            msg: deviceId
        }
        mutations.WEBSOCKET_SEND(state,message)
    },
    DESTORYED_WEB_SOCKET: (state) => {
        state.lockReconnect = true;
        if (state.webSocket) {
            state.webSocket.close();
        }
        console.log('断开websoket连接');
        state.initStatus = false;
        clearTimeout(state.reconnectData); //离开清除 timeout
        clearTimeout(state.timeoutObj); //离开清除 timeout
        clearTimeout(state.serverTimeoutObj); //离开清除 timeout
    },
    WEBSOCKET_SEND: (state,data) => {
        if (state.isConn) {
            state.webSocket.send(JSON.stringify(data));
        }
    },
    // SAVE_WEB_SOCKET:(state) => {
    //     localStorage.setItem('webSocket',JSON.stringify(state.webSocket));
    // }
}


// var webSocket = {
//     params: '',
//     route: '',
//     // domain: 'wss://weixin.zbpm.szdbi.com/',
//     domain: 'ws://192.168.17.47:8010/',
//     heartbeat: 'websocket_heartbeat',
//     initWebSocket: function () {
//         console.log('启动中...');
//         let url = webSocket.domain + webSocket.route + '/' + webSocket.params
//         if ("WebSocket" in window) {
//             webSocket = new WebSocket(url);
//         } else {
//             _this.$notify.error({
//                 title: "提示",
//                 message: "当前浏览器不支持webSocket"
//             });
//         }
//         console.log("WebSocket连接中...");

//         //连接成功建立的回调方法
//         webSocket.onopen = function () {
//             console.log('连接成功')
//             isConn = true;
//             heatBeat(); //连接成功
//         };

//         //接收到消息的回调方法
//         webSocket.onmessage = function (e) {
//             heatBeat(); //收到消息会刷新心跳检测，如果一直收到消息，就推迟心跳发送
//             console.log('收到消息', e)
//             let jsonObj = JSON.parse(e.data);
//             webSocket.callback(jsonObj);
//         };

//         //连接发生错误的回调方法
//         _this.websocket.onerror = function () {
//             console.log('连接失败');
//             isConn = false;
//             reconnect();
//         };

//         //连接关闭的回调方法
//         webSocket.onclose = function () {
//             console.log('断开连接');
//             isConn = false;
//             reconnect();
//         };


//     },
//     destroyedWebSocket: function () {
//         lockReconnect = true;
//         socketTask.close(() => {
//             console.log('断开websoket连接');
//         });
//         clearTimeout(reconnectData); //离开清除 timeout
//         clearTimeout(timeoutObj); //离开清除 timeout
//         clearTimeout(serverTimeoutObj); //离开清除 timeout
//     },
//     websocketsend: function (data) {
//         if (isConn) {
//             socketTask.send({
//                 data: JSON.stringify(data)
//             });
//         }
//     },
//     callback: function (msg) { }
// }

module.exports = {
    namespaced: true,
    state,
    mutations
}
